import { render, staticRenderFns } from "./DeleteWebhook.vue?vue&type=template&id=0034276e&scoped=true&"
import script from "./DeleteWebhook.vue?vue&type=script&lang=ts&"
export * from "./DeleteWebhook.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteWebhook.vue?vue&type=style&index=0&id=0034276e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0034276e",
  null
  
)

export default component.exports